import { RUSSIAN_PHONE_LENGTH, DEFAULT_PHONE_TEMPLATE } from './constants';
/**
 * Утилита принимает телефон в виде строки, убирает из неё всё, кроме цифр,
 * форматирует по определенному шаблону и возвращает строку-результат.
 * Утилита поддерживает только российские номера.
 *
 * Если телефон начинается с +7, то плюс будет сохранен.
 * Если телефон не соответсвует российскому формату, то утилита вернёт неотформатированную строку.
 */
export var formatPhone = function formatPhone(_ref) {
  var phone = _ref.phone,
    _ref$template = _ref.template,
    template = _ref$template === void 0 ? DEFAULT_PHONE_TEMPLATE : _ref$template;
  var phoneStr = typeof phone === 'number' ? phone.toString() : phone;
  var clearedPhoneStr = phoneStr.replace(/\D/g, '');
  if (clearedPhoneStr.length !== RUSSIAN_PHONE_LENGTH) {
    return phoneStr;
  }
  var formattedPhone = clearedPhoneStr.replace(/(\d)(\d{3})(\d{3})(\d{2})(\d{2})/, template);
  return formattedPhone.startsWith('7') ? "+".concat(formattedPhone) : formattedPhone;
};